import React from 'react';
import { observer } from 'mobx-react';

import ModalRow from 'components/modal/layout/row';
import ModalButton from 'components/modal/layout/button';

const Footer = ({
  upsertModalRouteStore,
  activeTechnician,
  createTechnician,
  updateTechnician,
  showDeleteConfirmationModal,
}) => {
  const isDisabled = activeTechnician
    ? !upsertModalRouteStore.readyForUpdate
    : !upsertModalRouteStore.readyForCreation;

  return <ModalRow shouldBoundToBottom={true} shouldBeSpaceBetween={true}>
    <ModalButton
      isDisabled={isDisabled}
      color='blue'
      text='Save'
      onClick={activeTechnician ? updateTechnician : createTechnician}
    />
    {
      activeTechnician &&
      <ModalButton
        color='red'
        text='Delete'
        onClick={() => showDeleteConfirmationModal()}
      />
    }
  </ModalRow>;
};

export default observer(Footer);
